<!-- Asset management controls -->
<ng-template #aamBlockUi>
    <p-button
        [pTooltip]="saveButtonTooltip()"
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'journal.save-journal-first' | translate"
        [disabled]="!canSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<!-- make sure journalId is in there first render -->
<blockable-div #aamBlock [blocked]="!model.id" [blockUi]="aamBlockUi" class="min-h-[200px]">
    @if (journal?.id) {
        <div class="text-center m-4">
            @if (isComponentRendered()) {
                <app-asset-file-input
                    #assetFileInput
                    (selectFiles)="createAssets($event)"
                    [noUploadButton]="true"
                    [dropZoneTargetModelSig]="assetListWidget().table.el ?? undefined"
                />
            }
        </div>
        <app-widget-asset-list
            #assetList
            [showUploadButton]="true"
            (isComponentRendered)="isComponentRendered.set($event)"
            (selectFiles)="createAssets($event)"
            [modelIdSig]="journal.id"
            [modelTypeSig]="'JournalAsset'"
            [dataTestId]="'formly-journal-assets'"
        />
    }
</blockable-div>
